import { render, staticRenderFns } from "./table-filters-bar.vue?vue&type=template&id=4bc59668&scoped=true&"
import script from "./table-filters-bar.vue?vue&type=script&lang=js&"
export * from "./table-filters-bar.vue?vue&type=script&lang=js&"
import style0 from "./table-filters-bar.vue?vue&type=style&index=0&id=4bc59668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc59668",
  null
  
)

export default component.exports